import { IInTakeSurveyQuestion, InTakeSurveyQuestion } from '../builders/ap_intake_survey_builder';
import { IInTakeSurveyQuestionChoicesDatasource } from '../datasources/intake_survey_choices_datasource';

import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APIntakeSurveyNKHelper } from '../../preview_plan/helpers/intake_survey_nk_helper';
import { IInTakeSurveyQuestionDatasource } from '../datasources/intake_survey_questions_datasource';

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadInTakeSurveyPollCommand',
    function loadInTakeSurveyPollCommand(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      appConfigModel: any,
      InTakeSurveyConstants: any,
      ngAPIntakeSurveyNKHelper: APIntakeSurveyNKHelper,
      log: any,
      ngIntakeSurveyQuestionsDatasource: IInTakeSurveyQuestionDatasource,
      ngIntakeSurveyChoicesDatasource: IInTakeSurveyQuestionChoicesDatasource
    ) {
      return defineCommandORM('loadInTakeSurveyPollCommand', (deferred) => {
        const nkForIntakeSurvey = ngAPIntakeSurveyNKHelper.intakeSurveyNK;
        $http
          .get(`poll/${nkForIntakeSurvey}/`)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            const pollId = Object.keys(data.poll)[0];
            const activeQuestionIDs = data.poll[pollId].active_questions;

            const questions = _4.filter(data.question, (question: InTakeSurveyQuestion) =>
              _4.includes(activeQuestionIDs, question.id)
            );

            _4.map(questions, (question: IInTakeSurveyQuestion) => {
              const intakeSurveyNKConfigKey = _4.findKey(
                appConfigModel.model.member_configs,
                (appConfigModelValue) => appConfigModelValue === question.nk
              );
              if (intakeSurveyNKConfigKey) {
                question._computedNK = ngAPIntakeSurveyNKHelper.defaultNKforIntakeSurveyConfig(intakeSurveyNKConfigKey);
              } else {
                question._computedNK = question.nk;
              }
            });

            ngIntakeSurveyQuestionsDatasource.clear().write(questions);

            ngIntakeSurveyChoicesDatasource.clear().write(data.choice);

            deferred.resolve();
          })
          .catch((e: string) => {
            log.issue('loadInTakeSurveyPollCommand failed');
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/commands/load_ap_intake_survey_poll_command.ts